import React, {Component} from 'react';
import styled, {createGlobalStyle} from 'styled-components';
import posed, {PoseGroup} from 'react-pose'
import SvgFile from './SvgFile';
import ExportMenu from './ExportMenu'

const transition = {
  type: 'tween',
  // duration: 300
}

const AnimateBg = posed.div({
  enter: {
    opacity: 1,
    transition
  },
  exit: {
    opacity: 0,
    delay: 250,
    transition
  }
})

const AnimateModal = posed.div({
  enter: {
    y: 0,
    delay: 200,
    transition
  },
  exit: {
    delay: 50,
    y: '100vh',
    transition
  }
})

const Background = styled(AnimateBg)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${({theme}) => theme.color};
  align-items: center;
  justify-content: center;
  display: flex;
  z-index: 3000;
  overflow-x: hidden;
  overflow-y: auto;
`

const Modal = styled(AnimateModal)`
  position: absolute;
  max-width: 80%;
  background: ${({theme}) => theme.bg};
  border-radius: 0;
  padding: 12px;
  display:flex;
  align-items:center;
  justify-content:center;
`

const GlobalStyle = createGlobalStyle`
  body {
    overflow: hidden;
  }
`

class ExportModal extends Component{

  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e){
    e.stopPropagation();
  }

  render(){
    let {closeModal, objects, open} = this.props;
    return(
      <PoseGroup>
        {open && (
          <Background key={2342} onClick={closeModal}>
            <GlobalStyle />
            <Modal onClick={this.handleClick}>
              <SvgFile objects={objects} />
              <ExportMenu closeModal={closeModal} />
            </Modal>
          </Background>
        )}
      </PoseGroup>
    )
  }
}

export default ExportModal;